import TripPackageSet from '@itinerary/trip/TripPackageSet';
import { BusPackageLoader } from '@itinerary/trip/bus/BusPackageLoader';
import { type BusPackageLoaderConfig } from '@itinerary/trip/bus/types';
import type BusPackage from '@itinerary/trip/bus/BusPackage';
import {
    type BusFilterData,
    type BusFilters,
} from '@itinerary/trip/bus/BusModuleTypes';

export default class BusPackageSet extends TripPackageSet<
    BusFilterData,
    BusFilters,
    BusPackage
> {
    override loader: BusPackageLoader;

    get destinationTerminalCode() {
        return this.loader.destinationTerminalCode;
    }

    get originTerminalCode() {
        return this.loader.originTerminalCode;
    }

    protected override reset(
        config: BusPackageLoaderConfig,
        filters: Record<BusFilters, any>,
        minPrice?: number
    ) {
        super.reset(config, filters, minPrice);
        this.loader = new BusPackageLoader(config);
    }

    constructor(
        config: BusPackageLoaderConfig,
        /**
         * Contains filters that must be applied to the results
         */
        public override filters: Record<BusFilters, any>,

        /**
         * Minimum price that is obtained or expected from the current package set
         */
        public override minPrice?: number,

        public override isSuggestion = false
    ) {
        super(filters, minPrice);
        this.loader = new BusPackageLoader(config);
    }
}
